import { createFileRoute } from '@tanstack/react-router';
import Users from '../../../administration/src/components/Users';

export const Route = createFileRoute('/_secured/administration/users')({
  component: Users,
});
